/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Operation_Not_AllowedInputs */



/**
* | output |
* | --- |
* | "Email/password accounts are not enabled." |
*
* @param {Login_Error_Operation_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_operation_not_allowed = /** @type {((inputs?: Login_Error_Operation_Not_AllowedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Operation_Not_AllowedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les comptes email/mot de passe ne sont pas activés.")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail-/Passwortkonten sind nicht aktiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli account e-mail/password non sono abilitati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Учетные записи электронной почты и паролей не активированы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las cuentas de correo electrónico/contraseña no están habilitadas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电子邮件/密码帐户未启用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("電子メール/パスワード アカウントが有効になっていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल/पासवर्ड खाते सक्रिय नहीं हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As contas de e-mail/senha não estão ativadas.")
	return /** @type {LocalizedString} */ ("Email/password accounts are not enabled.")
});